<template>
    <div class="TextBlock">
        <slot>
            <span v-html="formatted"></span>
        </slot>
    </div>
</template>

<style></style>

<script type="text/babel">
export default {
    props: ['value'],

    computed: {
        formatted() {
            return typeof this.value === 'string'
                ? this.value.replace(/(?:\r\n|\r|\n)/g, '<br />')
                : ''
        },
    },
}
</script>
